angular.module('myappointments').factory('MyAppointmentsService',
    [ function () {
        'use strict';

        var requestedAppointment = {
            Message: { Id: ''},
            Calendar: { Id: '', Description: ''},
            AppointmentType: { Id: ''},
            RequestDateTime: '',
            Reason: ''
        };

        var newRequestedAppointment = true;

        function cacheRequestedAppointment(appointment) {
            requestedAppointment.Message.Id = appointment.Message.Id;
            requestedAppointment.Calendar.Id = appointment.Calendar.Id;
            requestedAppointment.Calendar.Description = appointment.Calendar.Description;
            requestedAppointment.AppointmentType.Id = appointment.AppointmentType.Id;
            requestedAppointment.RequestDateTime = appointment.RequestDateTime;
            requestedAppointment.Reason = appointment.Reason;
            newRequestedAppointment = false;
        }

        function getRequestedAppointment() {
            return requestedAppointment;
        }

        function clearRequestedAppointment() {
            requestedAppointment.Message.Id = '';
            requestedAppointment.Calendar.Id = '';
            requestedAppointment.Calendar.Description = '';
            requestedAppointment.AppointmentType.Id = '';
            requestedAppointment.RequestDateTime = '';
            requestedAppointment.Reason = '';
            newRequestedAppointment = true;
            //providerName = '';  // get rid of providerName
        }

        function isNewRequestedAppointment() {
            return newRequestedAppointment;
        }


        function isCheckIn(appointmentStatusId) {
            return appointmentStatusId.toUpperCase() === 'CD2A0578-0C89-4151-B4E9-66ED9D5B4995';
        }

        function isDischarged(appointmentStatusId) {
            return appointmentStatusId.toUpperCase() === '31886389-631F-4D03-BC28-B4DB87E9B172';
        }

        function isAppointmentToday(appointmentDateTime) {
            if (!appointmentDateTime) {
                return false;
            }

            var diff = moment(appointmentDateTime).diff(moment(), 'days');
            return (diff === 0);
        }


        return {
            cacheRequestedAppointment: cacheRequestedAppointment,
            getRequestedAppointment: getRequestedAppointment,
            clearRequestedAppointment: clearRequestedAppointment,
            isNewRequestedAppointment: isNewRequestedAppointment,
            isCheckIn: isCheckIn,
            isDischarged: isDischarged,
            isAppointmentToday: isAppointmentToday
        };

    }]);